import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';

import randomstring from 'uuid/v4';

class Filter extends React.Component {
    state = {
        name: '',
        rules: this.props.duplicated, 
        programming: this.props.duplicated,
        programmingfields: this.props.duplicated,
        clonarpermisos: this.props.duplicated,
        client:
            this.props.session && this.props.session.info
                ? this.props.session.info.idCliente
                : undefined,
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (client, rules, programming, programmingfields, clonarpermisos, name) => (event) => {
        this.props.onClose(client, rules, programming, programmingfields, clonarpermisos, name);
    };

    render() {
        const { client, rules, programming, programmingfields, name, clonarpermisos } = this.state;
        const { intl, info, duplicated } = this.props;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <TextField
                        autoFocus
                        id="name"
                        name={'name'}
                        required
                        fullWidth
                        error={name.length < 4}
                        helperText={
                                name.length === 0
                                    ? intl.formatMessage({ id: 'required' })
                                    : name.length < 4
                                    ? intl.formatMessage({ id: 'min_length_4' })
                                    : ''
                        }
                        label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                        className={'flex_full_row upper'}
                        defaultValue={name}
                        onChange={this.handleChange}
                        margin="normal"
                        maxLength="128"
                        inputProps={{
                            maxLength: 128,
                        }}
                    />

                    {!duplicated &&
                        <div className="flex_full_row margin_top_32 align_center">
                            <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                                <InputLabel htmlFor="client">
                                    {intl.formatMessage({ id: 'clients' })}
                                </InputLabel>
                                <Select
                                    native
                                    value={client}
                                    onChange={this.handleChange}
                                    inputProps={{ name: 'client', id: 'client-id' }}
                                >
                                    <option key={randomstring()} value={undefined} />
                                    {info &&
                                        info.security &&
                                        info.security.clients &&
                                        info.security.clients.map((c) => {
                                            return (
                                                <option key={randomstring()} value={c.id}>
                                                    {c.nombre}
                                                </option>
                                            );
                                        })}
                                </Select>
                            </FormControl>
                        </div>
                    }
                    {duplicated &&
                        <div className="flex_full_row margin_top_32 align_center">
                            <div className="flex_full_column">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_clone_programming" />
                                </div>
                            </div>
                            <div className="flex_auto_column">
                                <Switch
                                    name={'programming'}
                                    checked={programming}
                                    onChange={this.handleChecked}
                                    value="programming"
                                    color="primary"
                                />
                            </div>
                        </div>
                    }
                    {duplicated &&
                        <div className="flex_full_row margin_top_32 align_center">
                            <div className="flex_full_column">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_clone_programmingfields" />
                                </div>
                            </div>
                            <div className="flex_auto_column">
                                <Switch
                                    name={'programmingfields'}
                                    checked={programmingfields}
                                    onChange={this.handleChecked}
                                    value="programmingfields"
                                    color="primary"
                                />
                            </div>
                        </div>
                    }
                    
                    {duplicated &&
                        <div className="flex_full_row margin_top_32 align_center">
                            <div className="flex_full_column">
                                <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                    <FormattedMessage id="form_field_clone_clonarpermisos" />
                                </div>
                            </div>
                            <div className="flex_auto_column">
                                <Switch
                                    name={'clonarpermisos'}
                                    checked={clonarpermisos}
                                    onChange={this.handleChecked}
                                    value="clonarpermisos"
                                    color="primary"
                                />
                            </div>
                        </div>
                    }
                    <div className="flex_full_row margin_top_32 align_center">
                        <div className="flex_full_column">
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="form_field_clone_rules" />
                            </div>
                        </div>
                        <div className="flex_auto_column">
                            <Switch
                                name={'rules'}
                                checked={rules}
                                onChange={this.handleChecked}
                                value="rules"
                                color="primary"
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    {name && name.length >= 4 
                        ?
                            <Button onClick={this.handleClose(client, rules, programming, programmingfields, clonarpermisos, name)} color="primary" autoFocus>
                                <FormattedMessage id="accept" />
                            </Button>
                        :
                            <Button color="secondary" autoFocus>
                                 <FormattedMessage id="accept" />
                            </Button>
                    }
                    
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
        session: state.session,
    };
};

Filter = connect(
    mapStateToProps,
    null,
)(Filter);

Filter = injectIntl(Filter);

export default Filter;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/ClientsDialog.js